export default "__VITE_ASSET__c02cd33d__$_?nuxt_component=async__"